<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import ResizeMixin from '@/utils/resizeMixin'

export default {
  name: 'App',
  mixins: [ResizeMixin],
}
</script>
